/** @type {import('../help-index.js').HelpSidebarItem} */
export const MET_SAL_FILTERS_ITEM = {
  id: 'sales_filters',
  screenId: 'met-sal-filters',
  label: 'Filtros',
  description: 'Ventas desglosadas por dimensión.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Analizás ventas segmentadas para encontrar qué aporta más al total.',
      },
      {
        title: 'Pestañas de análisis',
        bullets: [
          'Tipo de factura — factura A, B, ticket, etc.',
          'Terminales de venta — por punto de venta / terminal.',
          'Usuarios — vendedor o usuario que emitió.',
        ],
      },
      {
        title: 'Productos',
        paragraphs: [
          'El ranking y análisis por artículo están en Métricas → Productos (Ranking de ventas, Margen y Ventas por producto).',
        ],
      },
      {
        title: 'Período y monedas',
        paragraphs: [
          'Elegí el rango de fechas y si unificás monedas. Cada pestaña muestra ranking o gráfico con totales por fila.',
        ],
      },
    ],
  },
}
